import { createFileRoute } from '@tanstack/react-router'
import { UserDetailPage } from '@/pages/Users/UserDetailPage'

export const Route = createFileRoute('/_authenticated/users_/$userId')({
  component: UserDetailPage,
})
